module.exports = __webpack_public_path__ + "img/bgi1.1d7a5c92.png";